import request from '../utils/request';
import type { ReportExportRequest } from '../components/reports/reportExportRequest';

/**
 * The shared report export call (§1.9 / §2.3 of the reports revamp).
 *
 * `responseType: 'blob'` is not optional: without it axios parses the bytes as text and the saved
 * xlsx/pdf is corrupt in a way that only shows up when someone opens the file. The explicit JSON
 * content type is needed because the response type does not imply the request type.
 *
 * Errors are left to the caller (`useReportExport` turns them into a toast) — a failed export must
 * not silently hand back an HTML error page as a "file".
 */
export async function postReportExport<TInput>(
  url: string,
  req: ReportExportRequest<TInput>,
): Promise<Blob> {
  const response = await request.post<Blob>(url, req, {
    responseType: 'blob',
    headers: { 'Content-Type': 'application/json' },
  });
  return response.data;
}
